import React from 'react'
import FormRegistration from './FormRegistration'
const Registration = () => {
    return (
        <>
            <div className="px-5 py-1 p-lg-0 bg-surface-secondary">
                <div className="d-flex justify-content-center">
                    <div className="col-lg-5 col-xl-4 p-6 p-xl-20 position-fixed start-0 top-0 h-screen overflow-y-hidden bg-primary d-none d-lg-flex flex-column">
                        {/* Logo */}
                        <a className="d-flex" href="#">
                            <img
                                src="https://i.ibb.co/52NvQB3/2462345.png"
                                className="h-10"
                                alt="..."
                            />
                            <h5 style={{ marginLeft: '10px' }}> FINder</h5>

                        </a>
                        {/* Title */}
                        <div className="mt-5 mb-10">
                            <h1 className="ls-tight font-bolder display-6 text-white mb-5">
                                Your Match is waiting for you
        </h1>
                            <p className="text-white text-opacity-80">
                                Register Now and Find the right person for you through our smart recommendation system
        </p>
                        </div>
                        {/* Circle */}

                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="red" viewBox="0 0 24 24" className="w-56 h-56 position-absolute bottom-0 end-20 transform translate-y-1/3 rotate-60" transform='rotate(45)'><path d="M12 4.248c-3.148-5.402-12-3.825-12 2.944 0 4.661 5.571 9.427 12 15.808 6.43-6.381 12-11.147 12-15.808 0-6.792-8.875-8.306-12-2.944z" /></svg>

                    </div>
                    <div className="col-12 col-md-9 col-lg-7 offset-lg-5 border-left-lg min-h-lg-screen d-flex flex-column justify-content-center py-lg-1 px-lg-20 position-relative mb-2">

                        <div className="row">
                            <div className="col-lg-10 col-md-9 col-xl-8 mx-auto ms-xl-0">
                                <div className="mt-10 mt-lg-5 mb-6 d-flex align-items-center d-lg-block">
                                    <span className="d-inline-block d-lg-block h1 mb-lg-6 me-3">
                                        👋
            </span>
                                    <h1 className="ls-tight font-bolder h2">Find your match by registering here</h1>
                                </div>
                                <FormRegistration />


                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default Registration
